import { ViewModel } from 'view_models/view_model'
import { Doctor } from 'entities/doctor'

export class DoctorViewModel extends ViewModel<Doctor> {
    public fullName = (): string => {
        if (!this.object.familyName || !this.object.givenName) {
            return ''
        }
        return `${this.object.familyName} ${this.object.givenName}`
    }
    public fullNameKana = (): string => {
        if (!this.object.familyNameKana || !this.object.givenNameKana) {
            return ''
        }
        return `${this.object.familyNameKana} ${this.object.givenNameKana}`
    }
    public fullNameView = (): JSX.Element => {
        if (!((this.object.familyName && this.object.givenName) || (this.object.familyNameKana && this.object.givenNameKana))) {
            return <div>{this.object.name}</div>
        }
        return (
            <div>
                <div style={{ fontSize: 10 }}>{this.fullNameKana()}</div>
                <div>{this.fullName()}</div>
            </div>
        )
    }
}
